export default __webpack_public_path__ + "static/media/agencies.07ea5bef.svg";